export const translations = {
  ko: {
    about: "회사소개",
    faq: "자주묻는 질문",
    contact: "문의하기",
    homeTitle: "메인 페이지",
    homeDesc: "회사 방문을 환영합니다.",
    aboutTitle: "회사소개",
    aboutDesc: "우리 회사를 소개합니다.",
    faqTitle: "자주묻는 질문",
    faqDesc: "궁금하신 점을 확인하세요.",

    aboutTitle1: "사업 분야",
    aboutDesc1:
      "차세대 모빌리티를 위한 고성능 자동차용 PCB 솔루션을 공급합니다.",
    biz1Title: "AVN",
    biz1Desc: "Audio, Video, Navigation 시스템을 위한 고신뢰성 다층 기판",
    biz2Title: "Telematics",
    biz2Desc: "차량-사물 간 통신(V2X) 및 커넥티드 카 서비스를 위한 핵심 부품",
    biz3Title: "Cluster",
    biz3Desc: "디지털 클러스터 및 운전자 정보 시스템을 위한 고정밀 PCB",
    bizTitle4: "제동 장치", // 추가
    bizTitle5: "조향 장치", // 추가
    bizTitle6: "레이다용 PCB", // 추가
    bizDesc4: "안전한 주행을 위한 고신뢰성 제동 시스템 컨트롤러 보드",
    bizDesc5: "정밀한 차량 제어를 지원하는 차세대 조향 시스템 기술",
    bizDesc6: "자율주행의 핵심인 ADAS용 고성능 레이다 모듈 PCB",

    aboutTitle2: "연혁 및 매출액",
    revenueLabel: "연간 매출액 (2025 예상)",
    revenueAmount: "1,300 억원",
    historyData: [
      { year: "2025", desc: "매출액 1,300억 달성 전망" },
      { year: "2021", desc: "매출액 1,000억 돌파" },
      { year: "2015", desc: "매출액 500억 달성" },
      { year: "2013", desc: "신도리코 CIS 공급" },
      { year: "2011", desc: "삼성테크윈 PCB 공급" },
      { year: "2010", desc: "현대모비스 및 LG전자 CAR사업부 PCB 공급" },
      { year: "2008", desc: "매출액 300억 달성" },
      { year: "2007", desc: "만도헬라(Mando-Hella) 거래 시작" },
      { year: "2006", desc: "삼성프린팅 PCB 공급" },
      { year: "2005", desc: "LG전자 거래 시작" },
      { year: "2003", desc: "대만 USI 제휴 및 PCBA 한국 공급" },
      { year: "2000", desc: "신도리코, 한국샤프 PCB 공급" },
      {
        year: "1999",
        desc: "회사 설립(9월 30일) 및 삼보컴퓨터/삼성전자 Main PCB 공급",
      },
    ],

    clientTitle: "주요 고객사",
    mapTitle: "찾아 오시는 길",
    addressLabel: "주소",
    faxLabel: "팩스",
    telLabel: "전화번호",
    addressValue: "경기도 성남시 분당구 야탑로81번길 10, 602호 (아미고타워)",
    faxValue: "031-622-1976",
    telValue: "031-622-1974",
    mapTitle: "찾아오시는 길",
    pcbGuide: "PCB 가이드",
    pcbIntroTitle: "1. PCB란?",
    pcbIntroDesc:
      "PCB(Printed Circuit Board)는 전자 부품을 고정하고 전기적으로 연결하는 회로 기판입니다.\n모든 전자 제품의 핵심 '브레인' 역할을 수행하는 기초 부품입니다.",
    pcbProcessTitle: "2. PCB 제조 공정",
    pcbTypesTitle: "3. PCB 종류",
    // 종류별 설명
    typeRigid: "Rigid PCB: 가장 일반적인 단단한 기판",
    typeFlex: "Flexible PCB: 굴곡진 곳에 쓰이는 휘어지는 기판",
    typeHDI: "HDI PCB: 고밀도 배선 기술이 적용된 정밀 기판",
    typeRF: "Rigid-Flex PCB: 단단함과 유연함이 결합된 기판",
    navAbout: "회사소개",
    navPcbGuide: "PCB 가이드",
    navContact: "문의하기",

    // PCB 가이드 드롭다운 항목
    menuPcbIntro: "PCB란?",
    menuPcbProcess: "PCB 공정",
    menuPcbTypes: "PCB 종류",

    // 공정 이미지 (앞서 정한 내용)
    processImg: "/pcb_process.png",
  },

  en: {
    about: "About Us",
    faq: "FAQ",
    contact: "Contact",
    homeTitle: "Main Page",
    homeDesc: "Welcome to our company.",
    aboutTitle: "About Us",
    aboutDesc: "Introducing our company and vision.",
    faqTitle: "FAQ",
    faqDesc: "Check frequently asked questions.",

    aboutTitle1: "Business Area",
    aboutDesc1:
      "Providing high-performance automotive PCB solutions for next-generation mobility.",
    biz1Title: "AVN",
    biz1Desc:
      "High-reliability multilayer boards for Audio, Video, and Navigation systems",
    biz2Title: "Telematics",
    biz2Desc: "Core components for V2X and connected car services",
    biz3Title: "Cluster",
    biz3Desc: "High-precision PCBs for digital instrument clusters",
    bizTitle4: "Braking System", // 추가
    bizTitle5: "Steering System", // 추가
    bizTitle6: "Radar ADAS", // 추가
    bizDesc4:
      "High-reliability braking system controller boards for maximum safety.",
    bizDesc5:
      "Next-generation steering system technology for precise vehicle control.",
    bizDesc6:
      "High-performance Radar module PCBs, the core of ADAS and autonomous driving.",

    aboutTitle2: "History & Growth",
    revenueLabel: "Annual Revenue (2025 Est.)",
    revenueAmount: "KRW 130B",
    historyData: [
      { year: "2025", desc: "Expected Revenue KRW 130B" },
      { year: "2021", desc: "Revenue exceeded KRW 100B" },
      { year: "2015", desc: "Reached KRW 50B in Revenue" },
      {
        year: "2013",
        desc: "Supplied CIS to Sindoh",
      },
      { year: "2011", desc: "Started PCB supply to Samsung Techwin" },
      {
        year: "2010",
        desc: "Started business with Hyundai Mobis & LG Electronics CAR Division",
      },
      { year: "2008", desc: "Reached KRW 30B in Revenue" },
      { year: "2007", desc: "Started business with Mando-Hella" },
      { year: "2006", desc: "Started PCB supply to Samsung Printing" },
      { year: "2005", desc: "Started business with LG Electronics" },
      {
        year: "2003",
        desc: "Partnership with USI (Taiwan) & Supplied PCBA to Korea",
      },
      { year: "2000", desc: "Started PCB supply to Sindoh and Sharp Korea" },
      {
        year: "1999",
        desc: "Company Founded (Sep 30) / Supplied Main PCB to TriGem & Samsung Electronics",
      },
    ],

    clientTitle: "Key Clients",
    mapTitle: "Location",
    addressLabel: "Address",
    faxLabel: "Fax",
    telLabel: "Tel",
    addressValue:
      "602ho, 10, Yatap-ro 81beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea",
    faxValue: "+82-31-622-1976",
    telValue: "+82-31-622-1974",
    mapTitle: "Location",

    pcbGuide: "PCB Guide",
    pcbIntroTitle: "1. What is a PCB?",
    pcbIntroDesc:
      "A Printed Circuit Board (PCB) is a foundational component that mechanically supports and electrically connects electronic components.\nIt acts as the 'brain' of all modern electronic devices.",
    pcbProcessTitle: "2. Manufacturing Process",
    pcbTypesTitle: "3. Product Portfolio",
    typeRigid: "Rigid PCB: Standard high-durability boards",
    typeFlex: "Flexible PCB: Flexible solutions for compact devices",
    typeHDI: "HDI PCB: High-density interconnects for advanced tech",
    typeRF: "Rigid-Flex PCB: Combination of rigid and flexible layers",

    navAbout: "About Us",
    navPcbGuide: "PCB Guide",
    navContact: "Contact",

    // PCB 가이드 드롭다운 항목
    menuPcbIntro: "What is PCB?",
    menuPcbProcess: "Manufacturing Process",
    menuPcbTypes: "Product Types",

    // 공정 이미지 (앞서 정한 내용)
    processImg: "/pcb_process_eng.png",
  },
};
